import React from 'react';
import { formatTimeRange, getEventDuration } from '../utils/timeHelpers';

const MobileEventItem = ({
                           event,
                           onClick,
                           className = '',
                           fillHeight = false,
                           style = {},
                         }) => {
  const getVariantClass = () => {
    // Owner calendar event types
    if (event.isOwnerConfirmed) {
      return 'calendar-mobile__event--confirmed';
    }
    if (event.isOwnerPending) {
      return 'calendar-mobile__event--pending';
    }
    if (event.isConfirmedOther) {
      return 'calendar-mobile__event--group';
    }
    // Trainer calendar event types
    if (event.bookingCount && event.bookingCount > 0) {
      return 'calendar-mobile__event--pending';
    }
    if (event.confirmed && event.dogDTO) {
      return 'calendar-mobile__event--confirmed';
    }
    if (event.trainingGroup) {
      return 'calendar-mobile__event--group';
    }
    if (event.isLocked) {
      return 'calendar-mobile__event--locked';
    }
    if (event.isUnavailable || event.isPast) {
      return 'calendar-mobile__event--unavailable';
    }
    return 'calendar-mobile__event--free';
  };

  const getTitle = () => {
    // Use displayTitle if available (from OwnerCalendar)
    if (event.displayTitle) return event.displayTitle;
    if (event.dogDTO?.name) return event.dogDTO.name;
    if (event.trainingGroup?.name) return event.trainingGroup.name;
    if (event.bookingCount > 0) return `${event.bookingCount} oczekujących`;
    if (event.isLocked) return event.isTemporary ? 'Nowa blokada' : 'Zablokowane';
    return event.title || 'Wolny termin';
  };

  const getSubtitle = () => {
    // Check for booked training info
    if (event.bookedTraining?.dogDTO?.name) {
      return event.bookedTraining.dogDTO.name;
    }
    if (event.ownerDTO) {
      return `${event.ownerDTO.firstName} ${event.ownerDTO.lastName}`;
    }
    if (event.serviceDTO?.name) {
      return event.serviceDTO.name;
    }
    return null;
  };

  const timeRange = formatTimeRange(event.startTime, event.endTime);
  const duration = getEventDuration(event.startTime, event.endTime);
  const subtitle = getSubtitle();

  const isClickable = event.canBook || event.canCancel;

  const combinedStyle = {
    ...(fillHeight ? { height: '100%', boxSizing: 'border-box' } : {}),
    ...style,
  };

  return (
      <div
          className={`calendar-mobile__event ${getVariantClass()} ${isClickable ? 'calendar-mobile__event--clickable' : ''} ${className}`}
          onClick={() => onClick?.(event)}
          role={isClickable ? 'button' : undefined}
          tabIndex={isClickable ? 0 : undefined}
          style={combinedStyle}
          onKeyDown={(e) => {
            if (isClickable && (e.key === 'Enter' || e.key === ' ')) {
              e.preventDefault();
              onClick?.(event);
            }
          }}
      >
        <div className="calendar-mobile__event-title">{getTitle()}</div>
        <div className="calendar-mobile__event-time">
          {timeRange} ({duration})
        </div>
        {subtitle && (
            <div className="calendar-mobile__event-subtitle">{subtitle}</div>
        )}
      </div>
  );
};

export default MobileEventItem;